import { Button } from '../../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../../../components/ui/dialog';
import { Info } from 'lucide-react';

const ReportInfo = ({ reportKey, glossary }) => {
  const description = glossary?.report_descriptions?.[reportKey] || 'No description available';
  const lines = description.split('\n');
  const title = lines[0] || 'About This Report';
  const content = lines.slice(1).join('\n');
  
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" className="h-6 px-2">
          <Info className="w-4 h-4 mr-1" />
          <span className="text-xs">Methodology</span>
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-3xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-cyan-400">{title}</DialogTitle>
        </DialogHeader>
        <div className="prose prose-invert prose-sm max-w-none">
          <pre className="whitespace-pre-wrap text-sm font-sans text-muted-foreground bg-transparent p-0 overflow-visible">
            {content}
          </pre>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ReportInfo;
